import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const updateCommentTemplate = (
  commentTemplateId: number,
  update: CommentTemplateUpdateRequest,
  orgId: number,
  jobId?: number,
) =>
  createGenericDispatcher<CommentTemplate>({
    name: 'UPDATE_COMMENT_TEMPLATE',
    loadFunction: () =>
      Api.post(`/comment-template/${commentTemplateId}`, {
        body: JSON.stringify({ ...update }),
      }),
    args: { commentTemplateId, update, jobId, orgId },
  });
